const { size, intersectionWith, isEqual } = require('lodash')

const areArraysIdentical = (sourceArray, targetArray) =>
  size(sourceArray) === size(targetArray) &&
  size(sourceArray) ===
    size(intersectionWith(sourceArray, targetArray, isEqual))

export default areArraysIdentical
